import Main from './main';
import Edit from './edit';
import Import from './import';

const routes = [
  {
    path: '/*',
    Component: Main,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id/edit',
    Component: Edit,
    props: {
      exact: true,
    },
  },
  {
    path: '/import',
    Component: Import,
    props: {
      exact: true,
    },
  },
];

export default routes;
